<template>
  <span>{{ amountForDisplay }}</span>
</template>

<script>
import { formatCreditAmount } from '@/utils/localeFormat'
export default {
  name: 'CreditAmount',
  props: {
    amount: {
      type: Number,
      required: true
    }
  },
  computed: {
    amountForDisplay() {
      return formatCreditAmount(this.amount)
    }
  }
}
</script>
